import { render, staticRenderFns } from "./OrderableProductTiers.vue?vue&type=template&id=3424d156&"
import script from "./OrderableProductTiers.vue?vue&type=script&lang=ts&"
export * from "./OrderableProductTiers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports